module.exports = BD.Model.extend({
    invoice: BD.belongsTo('Billy.Invoice'),
    createdTime: BD.attr('datetime'),
    entryDate: BD.attr('date'),
    flatFee: BD.attr('number'),
    percentageFee: BD.attr('number'),
    amount: BD.attr('number'),
    isVoided: BD.attr('boolean')
})
